var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48456 2.93036C9.04198 2.37789 9.04599 1.47814 8.49352 0.920711C7.94105 0.363284 7.0413 0.359269 6.48387 0.911743L3.75329 3.61806C2.73737 4.6249 1.89007 5.46463 1.28594 6.21688C0.652292 7.00589 0.170324 7.83511 0.0415533 8.84538C0.0138516 9.06271 0 9.28135 0 9.5C0 9.71865 0.0138525 9.93729 0.0415533 10.1546C0.170324 11.1649 0.652291 11.9941 1.28594 12.7831C1.89007 13.5354 2.73737 14.3751 3.75329 15.3819L6.48387 18.0883C7.04129 18.6407 7.94104 18.6367 8.49352 18.0793C9.04599 17.5219 9.04198 16.6221 8.48455 16.0696L5.81226 13.4211C4.72298 12.3415 3.99283 11.6148 3.50191 11.0035C3.47939 10.9755 3.45765 10.948 3.43665 10.9211H16.5789C17.3638 10.9211 18 10.2848 18 9.5C18 8.71517 17.3638 8.07895 16.5789 8.07895H3.43665C3.45765 8.05201 3.47939 8.02454 3.50191 7.9965C3.99283 7.38521 4.72298 6.65852 5.81226 5.57891L8.48456 2.93036Z",
    fill: "#828D99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.c50e37e4b060023c03b0084a9967f220.svg";
export { ForwardRef as ReactComponent };